import React from 'react';
import s from './EulaPage.module.css';

const EulaPage: React.FC = () => {
    return (
        <div className={s.eula_page}>
            <h1>End User License Agreement</h1>
            <p>
                <strong>UPDATED ON NOVEMBER 28th, 2024</strong>
            </p>
            <p>
                AIOHUB Inc. (“<strong>AIO</strong>”) grants you a license to use the app
                “SimpleeCreate” (the “App”) only if you accept all the terms and conditions outlined
                in this End User License Agreement (“Agreement”) and its Terms of Service, which can
                be accessed through
                <a href="http://www.simpleecreate.com"> www.simpleecreate.com</a> or the App.
            </p>
            <p>
                In the case of any inconsistencies between this Agreement and the Terms of Service,
                the Terms of Service shall take precedence. You must carefully read and understand
                the following terms and conditions, as they will be legally binding upon you. If you
                do not agree to the terms and conditions or do not want them to be legally binding
                on you, do not use the App.
            </p>

            <h2>1. Acknowledgement</h2>
            <p>
                This Agreement is between you and AIOHub only. You acknowledge that any subsidiaries
                of AIOHub are third-party beneficiaries of this Agreement and that AIOHub has the
                right to enforce this Agreement against you. AIOHub is solely responsible for the
                App and its content.
            </p>

            <h2>2. Objectionable Content Policy</h2>
            <p>
                AIOHub does not tolerate objectionable content or abusive users. You shall not
                submit any such content to AIOHub. Objectionable content includes, but is not
                limited to, content that is exploitative, obscene, harmful, threatening, abusive,
                harassing, hateful, defamatory, sexually explicit or pornographic, violent,
                inflammatory, discriminatory based on race, sex, religion, nationality, disability,
                sexual orientation, age or other such legally prohibited grounds, or is otherwise
                objectionable in AIO’s sole discretion.
            </p>

            <h2>3. Grant and Scope of License</h2>
            <p>
                AIOHub grants you a limited, non-sublicensable, non-exclusive, and non-transferable
                right to use the App on any branded products you own or control as permitted by the
                Usage Rules set forth in the App Store and Google Play Store Terms of Service. The
                App may also be accessed and used by other accounts associated with the purchaser
                through Family Sharing or volume purchasing.
            </p>

            <h2>4. Maintenance and Support</h2>
            <p>
                AIOHub is solely responsible for providing maintenance and support services with
                respect to the App, as specified in this Agreement, the Terms of Service, or as
                required by applicable law. There is no obligation for AIOHub to furnish any
                maintenance and support services.
            </p>

            <h2>5. Warranty</h2>
            <p>
                AIOHub disclaims all warranties regarding the App to the fullest extent permitted by
                law. If any warranty exists under law that cannot be disclaimed, AIOHub shall be
                solely responsible for such warranty. In the event of the App not conforming to an
                applicable warranty, you may notify AIOHub, who will refund the purchase price for
                the App. To the maximum extent permitted by law, AIOHub will have no other warranty
                obligation with respect to the App.
            </p>

            <h2>6. Product Claims</h2>
            <p>
                Subject to any limitations of liability in the Terms of Service and applicable law,
                AIOHub is responsible for addressing any claims related to the App or its use,
                including, but not limited to: (i) any product liability claim; (ii) any claim that
                the App does not conform to any applicable legal or regulatory requirement; and
                (iii) any claim arising under consumer protection or similar legislation.
            </p>

            <h2>7. Intellectual Property Rights</h2>
            <p>
                AIOHub shall not be obligated to indemnify or defend you with respect to any
                third-party claim arising out of or relating to the App. If AIO is required to
                provide indemnification by applicable law, despite the Terms of Service and this
                Agreement, AIO shall be solely responsible for the investigation, defense,
                settlement, and discharge of any claim that the App or your use of it infringes upon
                any third-party intellectual property rights.
            </p>

            <h2>8. Legal Compliance</h2>
            <p>
                You represent and warrant that (i) you are not located in a country that is subject
                to a U.S. Government embargo, or that has been designated by the U.S. Government as
                a “terrorist supporting” country; and (ii) you are not listed on any U.S. Government
                list of prohibited or restricted parties.
            </p>

            <h2>9. Governing Law</h2>
            <p>
                This Agreement is governed and will be construed in accordance with the laws
                applicable and in force in the State of Delaware, United States.
            </p>

            <h2>10. Termination</h2>
            <p>
                This Agreement is effective until terminated. AIOHub may, at its sole discretion, at
                any time terminate or suspend all or a portion of the App or your right to use the
                App. Upon termination of this Agreement, you shall cease all use of the App and
                delete all copies, full or partial, of the App.
            </p>

            <h2>11. Limitation of Liability</h2>
            <p>
                To the extent not prohibited by law, in no event shall AIOHub be liable for personal
                injury, or any incidental, special, indirect or consequential damages whatsoever,
                including, without limitation, damages for loss of profits, loss of data, business
                interruption or any other commercial damages or losses, arising out of or related to
                your use or inability to use the App, however caused, regardless of the theory of
                liability (contract, tort or otherwise) and even if AIOHub has been advised of the
                possibility of such damages. Some jurisdictions do not allow the limitation of
                liability for personal injury, or of incidental or consequential damages, so this
                limitation may not apply to you.
            </p>

            <h2>12. Indemnification</h2>
            <p>
                You agree to indemnify, defend and hold harmless AIOHub, its affiliates, licensors
                and service providers, and its and their respective officers, directors, employees,
                contractors, agents, licensors, suppliers, successors and assigns from and against
                any claims, liabilities, damages, judgments, awards, losses, costs, expenses or fees
                (including reasonable attorneys’ fees) arising out of or relating to your violation
                of this Agreement or your use of the App, including, but not limited to,
                Objectionable Content submitted by you, or your use of the App in violation of any
                applicable law or regulation.
            </p>

            <h2>13. General Terms</h2>
            <p>
                This Agreement constitutes the entire agreement between you and AIOHub regarding the
                use of the App. The failure of AIOHub to exercise or enforce any right or provision
                of this Agreement shall not operate as a waiver of such right or provision. If any
                provision of this Agreement is, for any reason, held to be invalid or unenforceable,
                the other provisions of this Agreement will be unimpaired and the invalid or
                unenforceable provision will be deemed modified so that it is valid and enforceable
                to the maximum extent permitted by law. Your relationship to AIO is that of an
                independent contractor, and neither party is an agent or partner of the other. You
                may not assign this Agreement or transfer any rights to use the App without the
                prior written consent of AIO. AIO may assign this Agreement without your prior
                written consent to its affiliates or in connection with a merger, acquisition,
                corporate reorganization, or sale of all or substantially all of its assets. This
                Agreement shall be binding upon and inure to the benefit of both parties and their
                respective successors and assigns.{' '}
            </p>

            <h2>14. Contact Information</h2>
            <p>
                If you have any questions about this Agreement, please contact AIOHub at{' '}
                <a href="mailto:support@aiohub.gg">support@aiohub.gg</a>.
            </p>
            <h2>Changes to this Agreement.</h2>
            <p>
                {' '}
                AIOHub reserves the right, in its sole discretion, to modify or replace this
                Agreement at any time. If a revision is material, AIOHub will provide at least 30
                days’ notice prior to any new terms taking effect. What constitutes a material
                change will be determined at AIOHub’s sole discretion. By continuing to access or
                use the App after any revisions become effective, you agree to be bound by the
                revised terms. If you do not agree to the new terms, you are no longer authorized to
                use the App.
            </p>
            <p style={{ marginBottom: 70 }}>
                You hereby acknowledge that you have read this agreement, understand it, and agree
                to be bound by its terms and conditions.
            </p>
        </div>
    );
};

export default EulaPage;
